import RootFooter from "./RootFooter";
export default RootFooter;
